import type { DropdownMenuContentProps } from '@radix-ui/react-dropdown-menu';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { useCallback } from 'react';

import type { MenuProps } from '../menu.types';
import * as styles from '../styles.css';
import * as desktopStyles from './styles.css';

type PointerDownOutsideHandler = NonNullable<
  DropdownMenuContentProps['onPointerDownOutside']
>;
type InteractOutsideHandler = NonNullable<
  DropdownMenuContentProps['onInteractOutside']
>;

export const DesktopMenu = ({
  children,
  items,
  portalOptions,
  rootOptions,
  contentOptions: {
    className = '',
    style: contentStyle = {},
    onPointerDownOutside,
    onInteractOutside,
    ...otherContentOptions
  } = {},
}: MenuProps) => {
  const handlePointerDownOutside = useCallback<PointerDownOutsideHandler>(
    e => {
      e.stopPropagation();
      onPointerDownOutside?.(e);
    },
    [onPointerDownOutside]
  );

  const handleInteractOutside = useCallback<InteractOutsideHandler>(
    e => {
      e.stopPropagation();
      onInteractOutside?.(e);
    },
    [onInteractOutside]
  );

  return (
    <DropdownMenu.Root {...rootOptions}>
      <DropdownMenu.Trigger asChild>{children}</DropdownMenu.Trigger>

      <DropdownMenu.Portal {...portalOptions}>
        <DropdownMenu.Content
          className={clsx(
            styles.menuContent,
            desktopStyles.contentAnimation,
            className
          )}
          sideOffset={5}
          align="start"
          style={{ zIndex: 'var(--affine-z-index-popover)', ...contentStyle }}
          onPointerDownOutside={handlePointerDownOutside}
          onInteractOutside={handleInteractOutside}
          {...otherContentOptions}
          side="bottom"
        >
          {items}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
